export default [
  { label: "create new game", route: "/game/create" },
  { label: "join existing game", route: "/game/join" },
  { label: "tips and tricks", route: "/tips" },
  { label: "tutorial", route: "/tutorial" },
  { label: "credits", route: "/credits" },
  { label: "story", route: "/story" },
  { label: "exit", route: "/exit" },
];
